import { MenuConfig } from '../api/menu-config';
import { PageConfig } from '../api/page-config';
import { UserGroup } from '../api/user-group';
import { Jwt, initialJwtValue } from '../units/auth/AuthProvider';

export const useStorage = () => {
    const getAuth = (): Jwt => {
        try {
            const value = localStorage.getItem('auth');
            return value ? (JSON.parse(value) as Jwt) : initialJwtValue;
        } catch (e) {
            return initialJwtValue;
        }
    };
    const setAuth = (value: Jwt) => {
        try {
            localStorage.setItem('auth', JSON.stringify(value));
        } catch (e) {
            throw e;
        }
    };
    const getUserGroups = (): UserGroup[] => {
        try {
            const value = localStorage.getItem('userGroup');
            return value ? (JSON.parse(value) as UserGroup[]) : [];
        } catch (e) {
            return [];
        }
    };
    const setUserGroups = (value: UserGroup[]) => {
        try {
            localStorage.setItem('userGroup', JSON.stringify(value));
        } catch (e) {
            throw e;
        }
    };
    const getMenuConfigs = (): MenuConfig[] => {
        try {
            const value = localStorage.getItem('menu');
            return value ? (JSON.parse(value) as MenuConfig[]) : [];
        } catch (e) {
            return [];
        }
    };
    const setMenuConfigs = (value: MenuConfig[]) => {
        try {
            localStorage.setItem('menu', JSON.stringify(value));
        } catch (e) {
            throw e;
        }
    };
    const getPageConfigs = (): PageConfig[] => {
        try {
            const value = localStorage.getItem('page');
            return value ? (JSON.parse(value) as PageConfig[]) : [];
        } catch (e) {
            return [];
        }
    };
    const setPageConfigs = (value: PageConfig[]) => {
        try {
            localStorage.setItem('page', JSON.stringify(value));
        } catch (e) {
            throw e;
        }
    };
    return { getAuth, setAuth, getUserGroups, setUserGroups, getMenuConfigs, setMenuConfigs, getPageConfigs, setPageConfigs };
};
